import React, { useEffect, useState } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import { useLocation, useParams } from "react-router-dom";
import StatusBadge from "../../../Components/UI/statusBadge";
import { useQuery } from "react-query";
import { showStores } from "../../../MyApi/stores";

import StatsCard from "../../../Components/UI/staticsCard";
import { StatsStoreShowConfig, tabs } from "./showConfig";
import StoreInfo from "../../../Components/stores/storesShow/storeInfo";
import AttachmentInfo from "../../../Components/stores/storesShow/attachmentInfo";
import BranchInfo from "../../../Components/stores/storesShow/branchInfo";
import LoadingSpinner from "../../../Components/UI/spinner";
import StoreStatusCard from "../../../Components/stores/storesShow/storeStatusCard";
import SkeletonWrapper from "../../../Components/UI/skeletonWrapper";
import EmployeInfo from "../../../Components/stores/storesShow/employesInfo";
import ProductInfo from "../../../Components/stores/storesShow/productInfo";
import AddonsInfo from "../../../Components/stores/storesShow/addonsInfo";
import OrdersInfo from "../../../Components/stores/storesShow/ordersInfo";
import CategoriesInfo from "../../../Components/stores/storesShow/categoriesInfo";
import ReviewsInfo from "../../../Components/stores/storesShow/reviewsInfo";
import TransactionsInfo from "../../../Components/stores/storesShow/transactionsInfo";
import EmptyList from "../../../Components/UI/messages/emptyList";

const StoreShowPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("attachments");
  const { data, isLoading, refetch } = useQuery(["showStores", id], () =>
    showStores(id),
  );
  const stores = data?.data?.Store || {};
  const {
    name,
    logo,
    is_closed,
    categories,
    store_setting,
    cover_image,
    commission_amount,
    section,
    created_at,
    currency_factor,
  } = stores;


   const store_type  =section?.type ;

  const StatsStoreConfig = StatsStoreShowConfig(
    store_setting,
    created_at,
    commission_amount,
    currency_factor,
  );


  useEffect(() => {
    if (location?.state?.tab !== "stores" && location?.state?.tab ) {
      setActiveTab(location?.state?.tab);
      console.log('location.state?.tab', location.state?.tab)
    }
  }, [location.state?.tab]);


  if (Object.values(stores).length === 0 && !isLoading) {
    return <EmptyList />;
  }
const page = location?.state?.page
  return (
    <div className="container-fluid">
      <HeaderBar
        title={"تفاصيل المتجر"}
        content={"عرض وإدارة معلومات المتجر"}
        isBack={true}
        indexPath={`/stores`}
        page={page}
      />
      <StoreStatusCard
        is_closed={is_closed}
        categories={categories}
        logo={logo}
        name={name}
        id={id}
        refetch={refetch}
      />
      <div className="row g-3 mt-3">
        {StatsStoreConfig.map((stats, i) => (
          <div className="col-md" key={i}>
            <StatsCard {...stats} isLoading={isLoading} />
          </div>
        ))}
      </div>

      <div className="card rounded-3 shadow-sm ">
        <div className="card-body">
          <div className="rounded-4 bg-smoke p-2 px-3">
            <ul className="row">
              {tabs.map((tab) => (
                <li
                  className={`col-md text-center p-2 ${
                    activeTab === tab.label ? "bg-white rounded-4" : ""
                  }`}
                  key={tab.id}
                  onClick={() => setActiveTab(tab.label)}
                >
                  {tab.name}
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-3">
            {activeTab === "storeInfo" && <StoreInfo {...stores} />}
            {activeTab === "attachments" && (
              <AttachmentInfo
                isLoading={isLoading}
                logo={logo}
                cover_image={cover_image}
                storeId={id}
                refetch={refetch}
              />
            )}

            {activeTab === "branches" && <BranchInfo id={id} name={name} />}
            {activeTab === "emplopyes" && <EmployeInfo id={id} name={name} />}
            {activeTab === "products" && <ProductInfo id={id} name={name} store_type={store_type} />}
            {activeTab === "addons" && <AddonsInfo currency_factor={currency_factor} store_id={id} />}
            {activeTab === "orders" && <OrdersInfo id={id} />}
            {activeTab === "categories" && <CategoriesInfo id={id} name={name} />}
            {activeTab === "reviews" && <ReviewsInfo id={id} />}
            {activeTab === "FinancialTransactions" && (
              <TransactionsInfo id={id} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreShowPage;
